import { render, staticRenderFns } from "./westStatistics.vue?vue&type=template&id=0a45da18&scoped=true"
import script from "./westStatistics.vue?vue&type=script&lang=js"
export * from "./westStatistics.vue?vue&type=script&lang=js"
import style0 from "./westStatistics.vue?vue&type=style&index=0&id=0a45da18&prod&scoped=true&lang=css"
import style1 from "./westStatistics.vue?vue&type=style&index=1&id=0a45da18&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a45da18",
  null
  
)

export default component.exports